export enum ProductsColumnIndexes {
  PRODUCT_NAME = 0,
  VENDOR_NAME = 1,
}

export enum ProductsColumnKeys {
  PRODUCT_NAME = 'name',
  VENDOR_NAME = 'vendor.name',
}

export interface ProductRecord {
  _id: string;
  name: string;
  vendor: {
    name: string;
  };
}

export interface ProductGridItem {
  name: string;
  'vendor.name': string;
}
